import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import CalculatorLoader from "@/components/CalculatorLoader/CalculatorLoader.vue";
import { useRootStore } from "@/store/root";
import { useSearchStore } from "@/store/searchModule";
import { useBookingStore } from "@/store/bookingModule";
import { requestEmbedScrollTop } from "@/utils/scrollToTopForModal";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingTransitionBackdrop',
  props: {
    visible: { type: Boolean },
    variant: { default: "belowBookingFooter" }
  },
  setup(__props: any) {

const props = __props as { visible: boolean, variant: "belowBookingFooter" | "coverSearchChrome" };



const { t } = useI18n();
const rootStore = useRootStore();
const searchStore = useSearchStore();
const bookingStore = useBookingStore();

const loadingLabel = computed(() => {
  if (bookingStore.completingBooking) {
    return t("message.BOOKING_TRANSITION_SUBMITTING");
  }
  /*
   * "Suchergebnisse werden geladen" only when leaving booking → search.
   * `previousPage` stays "booking" for the whole wizard, so it must not alone
   * drive this label (and a stuck globalSpinner must not either).
   */
  const leavingBookingForSearch =
    rootStore.globalSpinnerActive &&
    !rootStore.redirectBooking &&
    searchStore.previousPage === "booking";
  if (leavingBookingForSearch) {
    return t("message.SEARCH_RESULTS_LOADING");
  }
  return searchStore.allowRequestQuote || rootStore.isQuoteRequest
    ? t("message.BOOKING_TRANSITION_LOADING_QUOTE")
    : t("message.BOOKING_TRANSITION_LOADING");
});

const overlayKind = computed(() =>
  props.variant === "coverSearchChrome"
    ? "booking-transition-overlay--global"
    : "booking-wizard-nav-overlay",
);

watch(
  () => props.visible,
  (visible) => {
    if (!visible) return;
    // Scroll host + iframe to top before the panel is noticed mid-viewport.
    requestEmbedScrollTop();
  },
);

/*
 * Do not toggle `body.no-scroll` here: `overflow: hidden` on body breaks `position: sticky`
 * on `.app-header.sticky-top`. Scroll behind the overlay is blocked via `@wheel` /
 * `@touchmove` on the backdrop layer; fixed/sticky chrome is lifted above the dimmer in
 * `styles/index.scss` (`body:has(.calculator-loader-backdrop…)`).
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["calculator-loader-backdrop", _unref(overlayKind)]),
            "aria-hidden": "true",
            onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, null, 34),
          _createElementVNode("div", {
            class: _normalizeClass(["calculator-loader-box booking", _unref(overlayKind)])
          }, [
            _createVNode(CalculatorLoader, {
              fixed: "",
              anchor: "top",
              label: _unref(loadingLabel)
            }, null, 8, ["label"])
          ], 2)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})